import { Ref, ref } from 'vue'
import { ConfiguredMiddleware } from 'wretch/types'

export function useRequestMiddleware(): {
  requestMiddleware: ConfiguredMiddleware
  requestUrl: Ref<string | undefined>
} {
  const requestUrl = ref<string>()

  const requestMiddleware: ConfiguredMiddleware = (next) => (url, opts) => {
    requestUrl.value = url

    return next(url, opts)
  }

  return {
    requestMiddleware,
    requestUrl,
  }
}
